export default "__VITE_ASSET__CSO9l92T__"